import { Directive, HostListener, ElementRef, ViewChild, Input } from '@angular/core';
import { CdkMenuTrigger } from '@angular/cdk/menu';

@Directive({
  selector: '[menuTriggerRestrictOnKeydown]'
})
export class MenuTriggerOnKeydownDirective {
  @Input() isMenu: boolean = false;
  @ViewChild(CdkMenuTrigger) trigger: CdkMenuTrigger;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if(event && (this.isMenu || (!this.isMenu && event?.key === ' '))) // this also takes input fields under the accordion becuase we need to type space also.
      event?.stopPropagation();
  }
}
